module.exports = __webpack_public_path__ + "static/media/energy-flexibility-simulator-img-004.df194fa5.jpg";